import experiment from '@motionelements/core/src/store/modules/experiment.js';

export default {
  namespaced: true,
  state: () => experiment.state,
  getters: experiment.getters,
  actions: experiment.actions,
  mutations: experiment.mutations,
};
